import { useState } from 'react';
import { Link } from 'react-router-dom';

interface MobileDropdowns {
  osgb: boolean;
  egitimler: boolean;
  danismanlik: boolean;
  laboratuvar: boolean;
}

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [mobileDropdowns, setMobileDropdowns] = useState<MobileDropdowns>({
    osgb: false,
    egitimler: false,
    danismanlik: false,
    laboratuvar: false
  });
  const [desktopDropdowns, setDesktopDropdowns] = useState<MobileDropdowns>({
    osgb: false,
    egitimler: false,
    danismanlik: false,
    laboratuvar: false
  });

  const toggleMobileDropdown = (section: keyof MobileDropdowns) => {
    setMobileDropdowns(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const toggleDesktopDropdown = (section: keyof MobileDropdowns) => {
    setDesktopDropdowns(prev => ({
      osgb: false,
      egitimler: false,
      danismanlik: false,
      laboratuvar: false,
      [section]: !prev[section]
    }));
  };

  const closeAllDesktopDropdowns = () => {
    setDesktopDropdowns({
      osgb: false,
      egitimler: false,
      danismanlik: false,
      laboratuvar: false
    });
  };

  const handleMenuToggle = () => {
    try {
      setIsMenuOpen(!isMenuOpen);
    } catch (error) {
      console.error('Error toggling menu:', error);
    }
  };

  const handleDropdownToggle = (section: keyof MobileDropdowns) => {
    try {
      toggleMobileDropdown(section);
    } catch (error) {
      console.error(`Error toggling ${section} dropdown:`, error);
    }
  };

  const handleDesktopDropdownToggle = (section: keyof MobileDropdowns) => {
    try {
      toggleDesktopDropdown(section);
    } catch (error) {
      console.error(`Error toggling ${section} dropdown:`, error);
    }
  };

  return (
    <header className="bg-white shadow-md fixed w-full top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-3">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" onClick={closeAllDesktopDropdowns}>
              <img 
                src="https://static.readdy.ai/image/69983b9b992309f9f345f22b715baa7c/9064e6cef4f3a2eddd558022a58e0363.png" 
                alt="ASSA OSGB" 
                className="h-10"
                onError={(e) => {
                  console.error('Error loading logo image:', e);
                  e.currentTarget.style.display = 'none';
                }}
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6">
            <Link to="/kurumsal" className="text-gray-700 hover:text-red-600 font-medium text-sm" onClick={closeAllDesktopDropdowns}>KURUMSAL</Link>
            
            <div className="relative">
              <button 
                onClick={() => handleDesktopDropdownToggle('osgb')}
                className="text-gray-700 hover:text-red-600 font-medium flex items-center text-sm cursor-pointer"
              >
                OSGB <i className={`ri-arrow-down-s-line ml-1 transition-transform ${desktopDropdowns.osgb ? 'rotate-180' : ''}`}></i>
              </button>
              {desktopDropdowns.osgb && (
                <div className="absolute top-full left-0 bg-white shadow-lg rounded-lg py-2 w-64 mt-2">
                  <Link to="/osgb/isyeri-hekimi" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={closeAllDesktopDropdowns}>İşyeri Hekimi</Link>
                  <Link to="/osgb/is-guvenligi-uzmani" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={closeAllDesktopDropdowns}>İş Güvenliği Uzmanı</Link>
                  <Link to="/osgb/diger-saglik-personeli" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={closeAllDesktopDropdowns}>Diğer Sağlık Personeli</Link>
                  <Link to="/osgb/risk-degerlendirmesi" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={closeAllDesktopDropdowns}>Risk Değerlendirmesi ve Acil Durum Eylem Planı</Link>
                </div>
              )}
            </div>

            <div className="relative">
              <button 
                onClick={() => handleDesktopDropdownToggle('egitimler')}
                className="text-gray-700 hover:text-red-600 font-medium flex items-center text-sm cursor-pointer"
              >
                EĞİTİMLER <i className={`ri-arrow-down-s-line ml-1 transition-transform ${desktopDropdowns.egitimler ? 'rotate-180' : ''}`}></i>
              </button>
              {desktopDropdowns.egitimler && (
                <div className="absolute top-full left-0 bg-white shadow-lg rounded-lg py-2 w-64 mt-2">
                  <Link to="/egitimler/isg-temel-egitimi" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={closeAllDesktopDropdowns}>İSG Temel Eğitimi</Link>
                  <Link to="/egitimler/yuksekte-calisma-egitimi" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={closeAllDesktopDropdowns}>Yüksekte Çalışma Eğitimi</Link>
                  <Link to="/egitimler/yangin-egitimi" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={closeAllDesktopDropdowns}>Yangın Eğitimi Ve Tatbikatı</Link>
                  <Link to="/egitimler/acil-durum-egitimleri" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={closeAllDesktopDropdowns}>Acil Durum Eğitimleri</Link>
                  <Link to="/egitimler/ilkyardim-egitimi" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={closeAllDesktopDropdowns}>İlkyardım Eğitimi</Link>
                  <Link to="/egitimler/meslek-egitimi" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={closeAllDesktopDropdowns}>Meslek Eğitimi ve MYK</Link>
                </div>
              )}
            </div>

            <div className="relative">
              <button 
                onClick={() => handleDesktopDropdownToggle('danismanlik')}
                className="text-gray-700 hover:text-red-600 font-medium flex items-center text-sm cursor-pointer"
              >
                DANIŞMANLIK <i className={`ri-arrow-down-s-line ml-1 transition-transform ${desktopDropdowns.danismanlik ? 'rotate-180' : ''}`}></i>
              </button>
              {desktopDropdowns.danismanlik && (
                <div className="absolute top-full left-0 bg-white shadow-lg rounded-lg py-2 w-64 mt-2">
                  <Link to="/danismanlik/cevre-danismanligi" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={closeAllDesktopDropdowns}>Çevre Danışmanlığı</Link>
                  <Link to="/danismanlik/ortam-olcumleri" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={closeAllDesktopDropdowns}>Ortam Ölçümleri</Link>
                  <Link to="/danismanlik/periyodik-kontroller" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={closeAllDesktopDropdowns}>Periyodik Kontroller</Link>
                  <Link to="/danismanlik/tehlikeli-madde" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={closeAllDesktopDropdowns}>Tehlikeli Madde Ve Güvenlik Danışmanlığı</Link>
                  <Link to="/danismanlik/hirdavat-kkd" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={closeAllDesktopDropdowns}>Hırdavat ve KKD Danışmanlığı</Link>
                  <Link to="/danismanlik/pkd-atex" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={closeAllDesktopDropdowns}>Patlamadan Korunma Dokümanı (PKD) ve ATEX Çözümleri</Link>
                </div>
              )}
            </div>

            <div className="relative">
              <button 
                onClick={() => handleDesktopDropdownToggle('laboratuvar')}
                className="text-gray-700 hover:text-red-600 font-medium flex items-center text-sm cursor-pointer"
              >
                LABORATUVAR <i className={`ri-arrow-down-s-line ml-1 transition-transform ${desktopDropdowns.laboratuvar ? 'rotate-180' : ''}`}></i>
              </button>
              {desktopDropdowns.laboratuvar && (
                <div className="absolute top-full left-0 bg-white shadow-lg rounded-lg py-2 w-64 mt-2">
                  <Link to="/laboratuvar/hizmet-laboratuvari" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={closeAllDesktopDropdowns}>Basit Hizmet Laboratuvarı</Link>
                  <Link to="/laboratuvar/ise-giris-saglik-raporu" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={closeAllDesktopDropdowns}>İşe Giriş Sağlık Raporu</Link>
                  <Link to="/laboratuvar/mobil-saglik-araci" className="block px-4 py-2 text-gray-700 hover:bg-gray-50" onClick={closeAllDesktopDropdowns}>Mobil Sağlık Aracı</Link>
                </div>
              )}
            </div>

            <Link to="/referanslar" className="text-gray-700 hover:text-red-600 font-medium text-sm" onClick={closeAllDesktopDropdowns}>REFERANSLAR</Link>
            <Link to="/iletisim" className="text-gray-700 hover:text-red-600 font-medium text-sm" onClick={closeAllDesktopDropdowns}>İLETİŞİM</Link>
          </nav>

          {/* Header Buttons */}
          <div className="hidden lg:flex items-center space-x-3">
            <a 
              href="https://ibys.assaosgb.com.tr/#/login-layout" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors whitespace-nowrap text-sm"
            >
              Assa CRM
            </a>
            <a 
              href="https://assaosgb.infomed.com.tr/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap text-sm"
            >
              Tetkik Sonuçları
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="lg:hidden text-gray-700 hover:text-red-600"
            onClick={handleMenuToggle}
            aria-label="Toggle menu"
          >
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden bg-white border-t py-4">
            <div className="flex flex-col space-y-4">
              <Link to="/kurumsal" className="text-gray-700 hover:text-red-600 font-medium">KURUMSAL</Link>
              
              {/* OSGB Mobile Dropdown */}
              <div>
                <button 
                  onClick={() => handleDropdownToggle('osgb')}
                  className="flex items-center justify-between w-full text-gray-700 hover:text-red-600 font-medium"
                  aria-expanded={mobileDropdowns.osgb}
                >
                  OSGB 
                  <i className={`ri-arrow-down-s-line transition-transform ${mobileDropdowns.osgb ? 'rotate-180' : ''}`}></i>
                </button>
                {mobileDropdowns.osgb && (
                  <div className="mt-2 ml-4 space-y-2">
                    <Link to="/osgb/isyeri-hekimi" className="block text-gray-600 hover:text-red-600">İşyeri Hekimi</Link>
                    <Link to="/osgb/is-guvenligi-uzmani" className="block text-gray-600 hover:text-red-600">İş Güvenliği Uzmanı</Link>
                    <Link to="/osgb/diger-saglik-personeli" className="block text-gray-600 hover:text-red-600">Diğer Sağlık Personeli</Link>
                    <Link to="/osgb/risk-degerlendirmesi" className="block text-gray-600 hover:text-red-600">Risk Değerlendirmesi</Link>
                  </div>
                )}
              </div>

              {/* EĞİTİMLER Mobile Dropdown */}
              <div>
                <button 
                  onClick={() => handleDropdownToggle('egitimler')}
                  className="flex items-center justify-between w-full text-gray-700 hover:text-red-600 font-medium"
                  aria-expanded={mobileDropdowns.egitimler}
                >
                  EĞİTİMLER 
                  <i className={`ri-arrow-down-s-line transition-transform ${mobileDropdowns.egitimler ? 'rotate-180' : ''}`}></i>
                </button>
                {mobileDropdowns.egitimler && (
                  <div className="mt-2 ml-4 space-y-2">
                    <Link to="/egitimler/isg-temel-egitimi" className="block text-gray-600 hover:text-red-600">İSG Temel Eğitimi</Link>
                    <Link to="/egitimler/yuksekte-calisma-egitimi" className="block text-gray-600 hover:text-red-600">Yüksekte Çalışma Eğitimi</Link>
                    <Link to="/egitimler/yangin-egitimi" className="block text-gray-600 hover:text-red-600">Yangın Eğitimi</Link>
                    <Link to="/egitimler/acil-durum-egitimleri" className="block text-gray-600 hover:text-red-600">Acil Durum Eğitimleri</Link>
                    <Link to="/egitimler/ilkyardim-egitimi" className="block text-gray-600 hover:text-red-600">İlkyardım Eğitimi</Link>
                    <Link to="/egitimler/meslek-egitimi" className="block text-gray-600 hover:text-red-600">MYK Eğitimleri</Link>
                  </div>
                )}
              </div>

              {/* DANIŞMANLIK Mobile Dropdown */}
              <div>
                <button 
                  onClick={() => handleDropdownToggle('danismanlik')}
                  className="flex items-center justify-between w-full text-gray-700 hover:text-red-600 font-medium"
                  aria-expanded={mobileDropdowns.danismanlik}
                >
                  DANIŞMANLIK 
                  <i className={`ri-arrow-down-s-line transition-transform ${mobileDropdowns.danismanlik ? 'rotate-180' : ''}`}></i>
                </button>
                {mobileDropdowns.danismanlik && (
                  <div className="mt-2 ml-4 space-y-2">
                    <Link to="/danismanlik/cevre-danismanligi" className="block text-gray-600 hover:text-red-600">Çevre Danışmanlığı</Link>
                    <Link to="/danismanlik/ortam-olcumleri" className="block text-gray-600 hover:text-red-600">Ortam Ölçümleri</Link>
                    <Link to="/danismanlik/periyodik-kontroller" className="block text-gray-600 hover:text-red-600">Periyodik Kontroller</Link>
                    <Link to="/danismanlik/tehlikeli-madde" className="block text-gray-600 hover:text-red-600">Tehlikeli Madde</Link>
                    <Link to="/danismanlik/hirdavat-kkd" className="block text-gray-600 hover:text-red-600">Hırdavat ve KKD</Link>
                    <Link to="/danismanlik/pkd-atex" className="block text-gray-600 hover:text-red-600">PKD ve ATEX</Link>
                  </div>
                )}
              </div>

              {/* LABORATUVAR Mobile Dropdown */}
              <div>
                <button 
                  onClick={() => handleDropdownToggle('laboratuvar')}
                  className="flex items-center justify-between w-full text-gray-700 hover:text-red-600 font-medium"
                  aria-expanded={mobileDropdowns.laboratuvar}
                >
                  LABORATUVAR 
                  <i className={`ri-arrow-down-s-line transition-transform ${mobileDropdowns.laboratuvar ? 'rotate-180' : ''}`}></i>
                </button>
                {mobileDropdowns.laboratuvar && (
                  <div className="mt-2 ml-4 space-y-2">
                    <Link to="/laboratuvar/hizmet-laboratuvari" className="block text-gray-600 hover:text-red-600">Basit Hizmet Laboratuvarı</Link>
                    <Link to="/laboratuvar/ise-giris-saglik-raporu" className="block text-gray-600 hover:text-red-600">İşe Giriş Sağlık Raporu</Link>
                    <Link to="/laboratuvar/mobil-saglik-araci" className="block text-gray-600 hover:text-red-600">Mobil Sağlık Aracı</Link>
                  </div>
                )}
              </div>

              <Link to="/referanslar" className="text-gray-700 hover:text-red-600 font-medium">REFERANSLAR</Link>
              <Link to="/iletisim" className="text-gray-700 hover:text-red-600 font-medium">İLETİŞİM</Link>
              
              <div className="flex flex-col space-y-2 pt-4">
                <a 
                  href="https://ibys.assaosgb.com.tr/#/login-layout" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors text-center whitespace-nowrap"
                >
                  Assa CRM
                </a>
                <a 
                  href="https://assaosgb.infomed.com.tr/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors text-center whitespace-nowrap"
                >
                  Tetkik Sonuçları
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
